module.exports = __webpack_public_path__ + "img/header-weddingRingsBudgetLow@2x.882be95.jpg";